import { Navigate, Route, Routes } from "react-router-dom";
import { HomePage } from "@/routes/HomePage";
import { AdminPage } from "@/routes/AdminPage";
import { UserManagementPage } from "@/routes/UserManagementPage";
import { IndicatorSettingsPage } from "@/routes/IndicatorSettingsPage";
import { SignInPage } from "@/routes/SignInPage";
import { SignUpPage } from "@/routes/SignUpPage";

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/users" element={<UserManagementPage />} />
      <Route path="/admin/indicators" element={<IndicatorSettingsPage />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
